module.exports = __webpack_public_path__ + "img/微信截图_20231026235905.09874d9b.png";